<template>
  <v-card class="insight-details" align="center" justify="center" min-width="21vw" max-width="30vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_InsightDetails') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="d-flex align-center justify-center px-10 py-10">
      <div class="d-flex justify-center">
        <v-img class="mb-3" position="center center" :src="insight.imageUrl" max-width="100px" max-height="100px" contain/>
      </div>
      <v-divider class="mx-7" vertical/>
      <div>
        <h2 class="text-start">{{ capitalize((this.$i18n.locale === 'en')? insight.insightType : insight.insightTypeES) }}</h2>
        <p class="text-start" v-html="getInsightDescription()"/>
        <v-btn style="width: 100%" class="d-flex mt-7" @click="close">{{ $t('btnOk') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "InsightDetails",
  props: {
    insight: Object,
  },
  methods: {
    capitalize(string){
      string = string.toString().replaceAll('_', ' ');
      return string.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    },
    getInsightDescription() {
      const locale = this.$i18n.locale;
      
      // Try to get description for the current locale
      const descriptionKey = `description${locale.toUpperCase()}`;
      
      // Return description for current language if available, or fall back to English
      if (this.insight[descriptionKey]) {
        return this.insight[descriptionKey];
      } else if (locale === "es" && this.insight.descriptionES) {
        return this.insight.descriptionES;
      } else {
        return this.insight.descriptionEN;
      }
    },
    close() {
      this.$emit('closeWindow');
    }
  }
}
</script>

<style>
.insight-details{
  background-color: var(--v-mainWhite-base) !important;
}
</style>
